export var ATDSModalTrackingVariant;
(function (ATDSModalTrackingVariant) {
    ATDSModalTrackingVariant["MINI"] = "mini";
    ATDSModalTrackingVariant["MEDIUM"] = "medium";
    ATDSModalTrackingVariant["MAX"] = "max";
    ATDSModalTrackingVariant["SLIDE"] = "slide";
    ATDSModalTrackingVariant["FULL"] = "full";
    ATDSModalTrackingVariant["DRAWER"] = "drawer";
})(ATDSModalTrackingVariant || (ATDSModalTrackingVariant = {}));
